var _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJmhzCorrection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M33.583 12.134v9.82H9.723v-11.36c0-3.14 2.54-5.68 5.68-5.68h11.02l7.16 7.22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M25.542 6.254v6.733h7.11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M5.673 32.778h3.656M5.673 27.38h3.656M33.19 27.38h3.657M5.673 21.982h31.174"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M29.356 31.375l-2.449 2.894-2.894-2.45"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M26.857 33.549a6.478 6.478 0 00-6.43-7.246 6.474 6.474 0 103.89 11.65"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 35.019,
    cy: 32.778,
    r: 1.441
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJmhzCorrection);
export default __webpack_public_path__ + "static/media/JMHZ-correction.ffaf7592e711cfaf4689035141a7455f.svg";
export { ForwardRef as ReactComponent };